import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { PartnerParametersService } from '@core/partner-parameters/partner-parameters.service';
import { SettingsScanFlowService } from '@features/settings/scan-flow/shared/settings-scan-flow.service';

@Injectable()
export class ScanFlowDisabledOrPermissionGuardService implements CanActivate {
    constructor(
        private settingsScanFlowService: SettingsScanFlowService,
        private partnerService: PartnerParametersService,
        private router: Router,
    ) { }

    public canActivate(): Observable<boolean> {
        const checkUserPermissionToScanFlowManagement: any = this.partnerService.checkUserPermissionToScanFlowManagement.bind(this.partnerService);
        const getBehavior: any = this.settingsScanFlowService.getBehavior.bind(this.settingsScanFlowService);

        return forkJoin([checkUserPermissionToScanFlowManagement(), getBehavior()])
            .pipe(take(1),
                map((results: any[]) => {
                    const userHasPermissionToBehavior: boolean = results[0];
                    const behaviorEnabled: boolean = results[1].scanFlowEnabled;

                    if (behaviorEnabled) {
                        return true;
                    }

                    if (!userHasPermissionToBehavior) {
                        this.router.navigate(['page-forbidden']);
                    }

                    return userHasPermissionToBehavior;
                }));

    }
}
